import { SrcSet } from '@nucleus/types/media/image';
import { Media, MediaOptions } from '@nucleus/types/web';
import { cloneDeep, merge, pick, sortBy } from 'lodash';

export const formatSrcSet = (srcSet?: SrcSet | SrcSet[]): string | undefined => {
  if (srcSet === undefined) {
    return;
  }

  if (!Array.isArray(srcSet)) {
    srcSet = [srcSet];
  }

  return sortBy(srcSet, 'dimensions.width')
    .map((srcSet) => `${srcSet.src} ${srcSet.dimensions.width}w`)
    .join(', ');
};

const AllowedMediaOptionPaths: Array<string> = [
  'useColor',
  'color',
  'blending',
  'image.scale',
  'image.tile',
  'video.image.scale',
  'video.image.tile',
];

export const mergeMediaOptions = (media?: Media, options?: MediaOptions): Media => {
  // We plan to mutate the objects. Clone them to avoid side effects.
  options = pick(cloneDeep(options) ?? {}, AllowedMediaOptionPaths);
  media = cloneDeep(media) ?? {};

  if (media?.presetMediaOrder !== 'first') {
    // Legacy behavior.
    if (options.useColor !== true) {
      delete options.color;
    }
    return merge({}, media, options);
  }

  // Color is "special" because you can set it in the preset.
  // Images and videos can only be set on the media.
  if (media.useColor !== true) {
    delete media.color;
    // Here we delete the useColor property so the useColor on the options will not be overridden.
    delete media.useColor;
  }

  if (options.useColor !== true) {
    delete options.color;
    // Here we do not delete the useColor property so that useColor will not be undefiled after the merge.
  }

  return merge({}, options, media);
};
